import { getAllPrograms } from '../data/programs/index.js'
import {
  buildCatalogProgram,
  getIsoDateInPoland,
  isCatalogVisible,
} from '../utils/catalog-data.js'
import { getProgramTerms } from './program-terms.js'

export async function getCatalogPrograms(options = {}) {
  /*
   * Program może działać na własnej stronie (terminy i sticky bar), zanim
   * będzie gotowy do pokazania w katalogu. Wtedy wystarczy ustawić w jego
   * danych `catalog.enabled: false`. Pole `catalog.visibleFrom` pozwala
   * przygotować program wcześniej i odsłonić go automatycznie danego dnia.
   */
  const today = options.today ?? getIsoDateInPoland()
  const registeredPrograms = getAllPrograms()
    .filter(program => isCatalogVisible(program.catalog, today))
  const settledResults = await Promise.allSettled(
    registeredPrograms.map(program =>
      getProgramTerms(program.programKey, options)
    )
  )
  const data = []
  const errors = []

  settledResults.forEach((result, index) => {
    const registeredProgram = registeredPrograms[index]

    if (result.status === 'rejected') {
      errors.push({
        programKey: registeredProgram.programKey,
        message: result.reason?.message || 'Nie udało się pobrać programu.',
      })
      return
    }

    if (result.value.errors.length) {
      errors.push(...result.value.errors.map(error => ({
        programKey: registeredProgram.programKey,
        ...error,
      })))
    }

    const catalogProgram = buildCatalogProgram(
      result.value.program,
      result.value.terms,
      {
        today,
        recommendedOrder: index,
      }
    )

    if (catalogProgram.terms.length > 0) {
      data.push(catalogProgram)
    }
  })

  return { data, errors }
}
